import Collection from "../generic/collection";
import Modals from "../modals"
import { render } from "../utils/render"
import { removeChildNodes } from "../utils/removeChildNodes"
import { getAttr } from "../utils/getAttr"
import { bubble } from "../utils/bubble"
import { getLocaleMsg } from "../utils/getLocaleMsg"
import { getCfg } from "../utils/getCfg";
import { bubbles as formBubbles } from "../forms"
import FormValidation from "../forms/validation";

export const instance = "[data-js-file-attach]";

export const els = {
  instance,
  input: "[data-js-file-attach-input]",
  addBtn: "[data-js-file-attach-add-btn]",
  fileList: "[data-js-file-attach-file-list]",
  fileRemove: "[data-js-file-attach-file-remove]",
  fileItem: "[data-js-file-attach-file]",
  name: '[data-js-file-attach-file-info="name"]',
  size: '[data-js-file-attach-file-info="size"]',
  msgBlock: '[data-js-file-attach-msg-block]',
  msgText: '[data-js-file-attach-msg-block-text]',
}

export const bubbles = {
  fileAttached: "file::attached",
  fileRemoved: "file::removed",
  filePreviewLoaded: "file::previewLoaded"
}

export class FileAttach {
  
  els = {
    instance
  }
  
  constructor(instance) {
    this.instance = instance;
    this.cfg = getCfg(this.instance, this.els.instance, FileAttachCollection.defaultCfg);
    this.addBtn = this.instance.querySelector(els.addBtn);
    this.input = this.getInput();
    this.msgBlock = this.instance.querySelector(els.msgBlock)
    this.fileList = this.instance.querySelector(els.fileList);
    this.update();
    this.bindEvents();
  }
  
  toggleBtn() {
    const { isHideNonEmpty, isMultiple } = this.cfg;
    if(isHideNonEmpty && !isMultiple) {
      this.instance.classList.add(FileAttachCollection.stateClasses.hideNonEmpty)
    }
  }
  
  update(files = this.getInitialFiles()) {
    this.files = files;
    this.toggleBtn();
  }
  
  getInput() {
    const insideInput = this.instance.querySelector(els.input);
    return (insideInput) ? insideInput : document.querySelector(`[name="${this.addBtn.getAttribute("for")}"]`);
  }
  
  getInitialFiles() {
    return [ ...this.getFileListNodes ].map((node) => {
      const getInfo = (selector) => node.querySelector(selector).textContent.trim();
      return {
        file: {
          name: getInfo(els.name),
          size: getInfo(els.size)
        },
        index: Number(node.getAttribute(getAttr(els.fileItem))),
        isInitial: true
      }
    })
  }
  
  get getFileListNodes(){
    return this.fileList.querySelectorAll(els.fileItem);
  }
  
  attach() {
    const { isMultiple, filter, maxSize, maxFiles, type, isCustomRenderer } = this.cfg;
    
    if (!isMultiple) {
      this.clear();
    }
    
    const prevent = (index, msg) => {
      FormValidation.setValidClassToEl(this.instance, false);
      this.removeFile(index);
      if(!isMultiple) {
        this.clear(true);
      }
      //Modals.openErrorModal(msg);
      if(this.msgBlock) {
        const msgText = this.msgBlock.querySelector(els.msgText);
        if(msgText) {
          msgText.textContent = msg;
          this.msgBlock.classList.add("isErrorTheme")
          this.addBtn.classList.remove("isHidden")
        }
      }
    }
    
    for(let i = 0; i < this.input.files.length; i++) {
      const file = this.input.files[i];
      const index = this.files.length ? Number(this.files[this.files.length - 1].index) + 1 : 0;
      const isValidSize = FileAttachCollection.isValidFileSize(file.size, maxSize);
      const isMaxFiles = (this.files.length >= maxFiles);
      const data = {
        name: file.name,
        size: FileAttachCollection.getMbFromBytes(file.size),
        index
      };
      if (!this.files.find(file => file.file.name === data.name)) {
        FormValidation.setValidClassToEl(this.instance, true);
        const extension = FileAttachCollection.getExtension(data.name);
        if(isMaxFiles) {
          prevent(index, getLocaleMsg("FILE_UPLOAD_ERROR_MAX"));
          return;
        }
        if(extension.length && !filter.includes(extension)) {
          prevent(index, getLocaleMsg("FILE_UPLOAD_ERROR_FORMAT"));
          return;
        }
        if(!extension.length) {
          prevent(index, getLocaleMsg("FILE_UPLOAD_ERROR_EXE"));
          return;
        }
        if(!isValidSize) {
          //prevent(index, () => Modals.openErrorModal(getLocaleMsg("FILE_UPLOAD_ERROR_SIZE")));
          prevent(index, getLocaleMsg("FILE_UPLOAD_ERROR_SIZE"));
          return;
        }
        
        this.files.push({ index, file, isInitial: false });
        
        if(this.msgBlock) {
          const msgText = this.msgBlock.querySelector(els.msgText);
          if(msgText) {
            msgText.textContent = getLocaleMsg("FILE_UPLOAD_VALID")
            this.msgBlock.classList.remove("isErrorTheme")
            this.addBtn.classList.add("isHidden")
            this.msgBlock.classList.add("isHidden")
          }
        }
        
        if(!isCustomRenderer) {
          render(this.fileList, FileAttachCollection.getFileTemplate(data, type));
          if(type === "image") {
            this.setPreview(file, data, index);
          }
        }
        
        bubble(this.instance, bubbles.fileAttached, this.getBubbleData(data));
      }
    }
  }
  
  setPreview(file, data, index) {
    FileAttachCollection.readURL(file).then(src => {
      const images = [ ...this.getFileListNodes ].filter((node) => Number(node.getAttribute(getAttr(els.fileItem))) === index);
      if(images.length) {
        const image = images[0].querySelector("img");
        if(image) {
          image.src = src.toString();
          image.alt = file.name;
          image.title = file.name;
          bubble(this.instance, bubbles.filePreviewLoaded, this.getBubbleData( { ...data, image }));
        }
      }
    }, () => Modals.openErrorModal());
  }
  
  removeFile(index) {
    const node = this.fileList.querySelector(`[${getAttr(els.fileItem)}="${index}"]`);
    if(node) {
      const inArrIndex = this.files.findIndex((el) => el.index === Number(index));
      if(~inArrIndex) {
        const { name, size } = this.files[inArrIndex].file;
        this.files.splice(inArrIndex, 1);
        this.input.value = "";
        bubble(node, bubbles.fileRemoved, this.getBubbleData({ index, name, size: FileAttachCollection.getMbFromBytes(size) }));
        if(!this.cfg.isCustomRenderer) {
          node.remove();
          if(!this.files.length) {
            removeChildNodes(this.fileList);
          }
        }
      } else {
        console.debug("Can't find file width index:", inArrIndex);
      }
    }
  }
  
  clear(isResetValue = false) {
    const { isMultiple } = this.cfg;
    this.files.forEach(({ index, name, size }) => {
      bubble(this.instance, bubbles.fileRemoved, this.getBubbleData({ index, name, size: FileAttachCollection.getMbFromBytes(size) }));
    });
    this.files = [];
    removeChildNodes(this.fileList);
    FormValidation.setValidClassToEl(this.instance, true);
    if(isMultiple || isResetValue) {
      this.input.value = "";
    }
  }
  
  getBubbleData(data = {}) {
    return {
      instance: this.instance,
      input: this.input,
      files: this.files,
      ...data
    }
  }
  
  handleClick(e) {
    const { target } = e;
    //if(target.matches(els.fileRemove)) {
    if(target.closest(els.fileRemove)) {
      e.preventDefault();
      const index = target.closest(els.fileItem).getAttribute(getAttr(els.fileItem));
      this.removeFile(index);
      this.addBtn.classList.remove("isHidden")
      this.msgBlock.classList.remove("isHidden")
    } else if (target.closest(els.addBtn)) {
      this.addBtn.classList.remove("isHidden")
      this.msgBlock.classList.remove("isHidden")
    }
  }
  
  handleChange() {
    this.attach();
    return true;
  }
  
  handleValidation({ detail }) {
    FormValidation.setValidClassToEl(this.instance, detail.isValid);
  }
  
  handleDrop(e) {
    e.stopPropagation();
    e.preventDefault();
    const files = e.dataTransfer.items;
    const transfer = new DataTransfer();
    if(files) {
      for (let i = 0; i < files.length; i++) {
        if(files[i].kind === "file") {
          const file = files[i].getAsFile();
          transfer.items.add(file);
        }
      }
      if(this.input) {
        this.input.files = transfer.files;
        this.attach();
      }
    }
    this.instance.classList.remove(FileAttachCollection.stateClasses.dragging);
  }
  
  handleDragEnter(e) {
    e.stopPropagation();
    e.preventDefault();
    let { target } = e;
    if(target.nodeType === 3) {
      target = target.parentNode;
    }
    if(target.closest(instance) || target === this.instance) {
      this.instance.classList.add(FileAttachCollection.stateClasses.dragging);
    }
  }
  
  handleDragOver(e) {
    e.stopPropagation();
    e.preventDefault();
  }
  
  handleDragLeave(e) {
    e.preventDefault();
    const { target } = e;
    if(target === this.instance) {
      this.instance.classList.remove(FileAttachCollection.stateClasses.dragging);
    }
  }
  
  handleDragStart(e) {
    if(e.target.closest(els.fileItem)) {
      e.preventDefault();
    }
  }
  
  
  bindEvents() {
    this.input.addEventListener("change", () => this.handleChange());
    this.instance.addEventListener("click", (e) => this.handleClick(e));
    this.instance.addEventListener("drop", (e) => { this.handleDrop(e) }, false);
    this.instance.addEventListener("dragenter", (e) => { this.handleDragEnter(e) });
    this.instance.addEventListener("dragleave", (e) => { this.handleDragLeave(e) });
    this.instance.addEventListener("dragover", (e) => { this.handleDragOver(e) }, false);
    this.instance.addEventListener("dragstart", (e) => { this.handleDragStart(e) });
    [ formBubbles.inputValid, formBubbles.inputInvalid ].forEach(eventName => this.input.addEventListener(eventName, (e) => this.handleValidation(e)));
  }
}

export class FileAttachCollection extends Collection {
  
  static icons = {
    default_: "attachment",
    archive: "attachment",
    image: "attachment"
  }
  
  static stateClasses = {
    dragging: "is-dragging",
    hideNonEmpty: "is-hide-non-empty"
  }
  
  static defaultCfg = {
    maxSize: 10,
    maxFiles: 1,
    isCustomRenderer: false,
    isHideNonEmpty: false,
    type: "default",
    isMultiple: false,
    filter: [ "pdf", "png", "jpeg", "jpg", "gif", "webp" ],
  }
  
  static fileSizes = [ "FILE_SIZE_BYTE", "FILE_SIZE_KB", "FILE_SIZE_MB", "FILE_SIZE_GB", "FILE_SIZE_TB" ].map((key) => getLocaleMsg(key));
  
  constructor() {
    super(instance, FileAttach);
  }
  
  static isValidFileSize(bytes, maxSizeMb = 10) {
    return (parseInt((Number(bytes) / 1024 / 1024).toString(), 10) <= maxSizeMb);
  }
  
  static getMbFromBytes(bytes) {
    bytes = Number(bytes);
    if (bytes === 0) {
      return `0 ${FileAttachCollection.fileSizes[0]}`;
    }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString());
    return Math.round(bytes / Math.pow(1024, i)) + " " + FileAttachCollection.fileSizes[i];
  }
  
  static readURL(file) {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = e => res(e.target.result);
      reader.onerror = e => rej(e);
      reader.readAsDataURL(file);
    });
  }
  
  
  static getRemoveBtnTemplate() {
    return `<button type="button" class="attachment__remove" data-js-file-attach-file-remove>
              <svg class="c-file-uploader-with-file__icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z" fill="#637088"></path>
              </svg>
              <span>Удалить</span>
           </button>`;
  }
  
  static getFileIcon(type) {
    const { default_, image, pdf, archive } = FileAttachCollection.icons;
    let icon = default_;
    switch(type) {
      case "image":
        icon = image;
        break;
      case "pdf":
        icon = pdf;
        break;
      case "archive":
        icon = archive;
        break;
    }
    
    return `<div class="attachment__icon">
              ${type === "image" ?
      `<img class="attachment__preview" src="" alt="" width="60" height="40" decoding="async" loading="lazy" />` :
      ` <svg class="icon">
                  <use href="#icon-${icon}"></use>
                </svg>` }
            </div>`;
  }
  
  static getExtension(name) {
    return (name.substring(name.lastIndexOf(".") + 1, name.length) || name).toLowerCase();
  }
  
  static getFileTemplate({ name, size, index }, type = FileAttachCollection.icons.default_, isRenderRemoveBtn = true, extraClasses = [ "fileAttach__list-item" ]) {
    //const icon = FileAttachCollection.getFileIcon(type);
    const removeBtn = FileAttachCollection.getRemoveBtnTemplate();
    return `
      <li class="attachment attachment--${type} ${extraClasses.join(" ")}" data-js-file-attach-file="${index}">
        <div class="attachment__info">
          <div class="attachment__name" title="${name}" data-js-file-attach-file-info="name">${name}</div>
          <div class="attachment__actions">
            <label for="fileAttach" class="attachment__label" data-js-file-attach-add-btn>
              <svg class="attachment__icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_3575_9245)">
                  <path d="M5.825 9.16406L2.5 12.4974L5.825 15.8307V13.3307H11.6667V11.6641H5.825V9.16406ZM17.5 7.4974L14.175 4.16406V6.66406H8.33333V8.33073H14.175V10.8307L17.5 7.4974Z" fill="#637088"></path>
                </g>
                <defs>
                  <clipPath id="clip0_3575_9245">
                    <rect width="20" height="20" fill="white"></rect>
                  </clipPath>
                </defs>
              </svg>
              Заменить
            </label>
            ${isRenderRemoveBtn ? removeBtn : ""}
          </div>
        </div>
      </li>`;
  }
  
}
